export const RELOAD_STATE = 'RELOAD_STATE';
export const SET_LABELS = 'SET_LABELS';
export const SET_STATUSINITIAL = 'SET_STATUSINITIAL';
export const SET_LOADING_COMPLETE = 'SET_LOADING_COMPLETE';
export const SET_HAS_ERROR = 'SET_HAS_ERROR';
export const SET_RESET_ERROR = 'SET_RESET_ERROR';
export const SET_CONTENT_BLOCK = 'SET_CONTENT_BLOCK';
export const SET_OCCUPATION = 'SET_OCCUPATION';
export const SET_OCCUPATIONS = 'SET_OCCUPATIONS';
export const SET_SPORTS = 'SET_SPORTS';
export const SET_DANGEROUS_SPORT = 'SET_DANGEROUS_SPORT';
export const SET_CPR = 'SET_CPR';
export const SET_PERMANENT_INJURY = 'SET_PERMANENT_INJURY';
export const SET_TERMINATION = 'SET_TERMINATION';
export const SET_PERSONAL_INFO = 'SET_PERSONAL_INFO';
export const SET_STAKEHOLDER = 'SET_STAKEHOLDER';
export const SET_PAYMENT = 'SET_PAYMENT';
export const SET_PAYMENT_PERIOD = 'SET_PAYMENT_PERIOD';
export const SET_CONSENT = 'SET_CONSENT';
export const SET_EBOKS_SUBSCRIPTION = 'SET_EBOKS_SUBSCRIPTION';
export const SET_GIFT_CARD = 'SET_GIFT_CARD';

export const SET_ADDITIONAL_COVERAGES = 'SET_ADDITIONAL_COVERAGES';
export const SET_SELECTED_MODIFIED_PACKAGE = 'SET_SELECTED_MODIFIED_PACKAGE';
export const SET_PACKAGE_MODIFIED_DETAILS = 'SET_PACKAGE_MODIFIED_DETAILS';
export const SET_COVERAGE_MODIFIED_DETAILS = 'SET_COVERAGE_MODIFIED_DETAILS';
export const SET_PACKAGE_INDEX = 'SET_PACKAGE_INDEX';
export const SET_KVHX_KEY = 'SET_KVHX_KEY';
export const SET_IS_PACKAGE_SUBMITTED = 'SET_IS_PACKAGE_SUBMITTED';
export const SET_IS_PACKAGE_PRICE_LOADING = 'SET_IS_PACKAGE_PRICE_LOADING';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_PHONENO = 'SET_PHONENO';
export const SET_NAME = 'SET_NAME';
export const SET_PACKAGE_DETAILS = 'SET_PACKAGE_DETAILS';
export const SET_PACKAGES = 'SET_PACKAGES';
export const SET_STATE_CHANGE = 'SET_STATE_CHANGE';
export const SET_RMO_REASON = 'SET_RMO_REASON';
export const SET_PROGRESS = 'SET_PROGRESS';
export const SET_BASKET_ACCEPTED = 'SET_BASKET_ACCEPTED';
export const SET_RESET = 'SET_RESET';
export const SET_PREV_ROUTE_CONFIG = 'SET_PREV_ROUTE_CONFIG';
export const SET_COVERAGE_ITEMS = 'SET_COVERAGE_ITEMS';
export const SET_ECOMMERCE_PRODUCT = 'SET_ECOMMERCE_PRODUCT';
export const SET_BANNER_TEXTS = 'SET_BANNER_TEXTS';
export const SET_SHOW_BANNER_OVERLAY = 'SET_SHOW_BANNER_OVERLAY';
export const SET_LOADING_OBJECT_CACHE = 'SET_LOADING_OBJECT_CACHE';
export const SET_FLOW = 'SET_FLOW';
